// src/services/paqueteService.js
import api from "@/services/api";

//  Paquetes de exámenes
export const paqueteService = {
  listar:     ()         => api.get("paquetes"),
  obtener:    (id)       => api.get(`paquetes/${id}`),
  crear:      (data)     => api.post("paquetes", data),
  actualizar: (id, data) => api.put(`paquetes/${id}`, data),
  eliminar:   (id)       => api.delete(`paquetes/${id}`),
};

//  Catálogo de exámenes (para el selector del formulario)
export const examenService = {
  listar: () => api.get("vwexamens"),
};

//  Pedidos
//
//  registrarDesdePaquete({ idAtencion, idPaquete, observacion,
//                          observacionTratamiento?, tipoTratamiento? })
//
//  El backend crea:
//    - 1 pedido  (cabecera)
//    - N pedido_det (uno por examen activo del paquete)
//    - 0|1 tratamiento (solo si se envía observacionTratamiento)
//
export const pedidoService = {
  registrarDesdePaquete: (data) =>
    api.post("pedidos/desde-paquete", data),
};